import Name from "@/components/Name"
import { MediaTypes, useLocalStore } from "@/context/StateContext"
import Types from "@/types"
import { cn } from "@/utilities/cn"
import { A } from "@solidjs/router"
import { createEffect, createSignal, Index } from "solid-js"

export default function MediaView() {
  const localStore = useLocalStore()
  const [media, setMedia] = createSignal<any[] | null>(null)
  const uploadFiles = async (files: FileList) => {
    if (!localStore.database) return
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      await localStore.createMedia(file)
    }
  }
  createEffect(async () => {
    if (!localStore.database) return
    const query = await localStore.database.find({
      selector: {
        type: Types.Category,
        target: Types.Media
      }
    })
    setMedia(query.docs.map((doc: any) => doc.origin))
    const subscription = localStore.database.changes({
      since: 'now',
      live: true,
      include_docs: true,
      selector: {
        type: Types.Category,
        target: Types.Media
      }
    }).on('change', (change: any) => {
      setMedia((media) => {
        if (change.deleted) {
          return media?.filter((id) => id !== change.doc.origin)
        }
        return media?.concat(change.doc.origin)
      })
    })
    return () => subscription.cancel
  })
  const handleDrop = (e: DragEvent) => {
    e.preventDefault()
    const files = e.dataTransfer?.files || new FileList()
    uploadFiles(files)
  }

  const handleFileChange = (e: Event) => {
    const input = e.target as HTMLInputElement
    const files = input.files || new FileList()
    uploadFiles(files)
  }

  let fileInputRef: HTMLInputElement | null = null
  const accept = ''
  const multiple = true
  return (
    <div class="flex flex-col p-4 gap-4 overflow-y-auto">
      <h1>Media</h1>
      {/* upload media dropbox */}
      <div class="w-full max-w-md p-8 space-y-4 bg-grue-200 dark:bg-grue-900 rounded-xl shadow-md">
        <h2 class="text-2xl font-bold text-center">Upload Media</h2>
        <div
          id="dropzone"
          class="flex items-center justify-center w-full h-64 border-2 border-dashed border-grue-300 rounded-lg cursor-pointer"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
          onClick={() => fileInputRef?.click()}
        >
          <span class="text-gray-500">
            {'Drag a file here or click to select'}
          </span>
        </div>
        <input
          ref={(element) => fileInputRef = element}
          type="file"
          class="hidden"
          multiple={multiple}
          accept={accept}
          onChange={handleFileChange}
        />
      </div>

      <Index each={media()} fallback={<p>No media found</p>}>
        {(mediaItem) => (
          <A class={"flex flex-row gap-2 p-4 border border-gray-200 rounded"} href={`/media/${mediaItem()}`}>
            <Name id={mediaItem()} />
          </A>
        )}
      </Index>
    </div>
  )
}
